<div class="glass">
    <div class="glass-content">
        <h4 class="glass-content-title">{{ 'WebApp.v1.Shared.InvalidPhone.Title' | translate }}</h4>
        <div class="glass-content-description">
            {{ 'WebApp.v1.Shared.InvalidPhone.Description' | translate }}
        </div>
        <div class="glass-content-description">{{ 'WebApp.v1.Shared.InvalidPhone.ThankYou' | translate }}</div>

        @if (errorMessage) {
            <div class="glass-content-error">{{ errorMessage }}</div>
        }

        <form [formGroup]="form">
            <div class="row phone">
                <app-phone-input formControlName="phone"></app-phone-input>
            </div>
        </form>
    </div>
    <div class="glass-footer">
        <app-button
            class="button"
            [disabled]="form.invalid"
            iconLeft="fa-solid fa-check"
            [label]="'WebApp.v1.Shared.Buttons.Complete' | translate"
            iconColor="#57DF8E"
            [fontSize]="14"
            [showOutlineOnHover]="false"
            backgroundColor="transparent"
            (click)="submitForm()"></app-button>
    </div>
</div>